var React = require('react');

function TwitterX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X"),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"key":2},React.createElement("g",{"id":"Layer_1"},React.createElement("path",{"className":"cls-1","d":"M177.9,127L287.2,0h-25.9l-94.9,110.3L90.6,0H3.2l114.6,166.8L3.2,300h25.9l100.2-116.5,80,116.5h87.4l-118.9-173h0ZM142.5,168.3l-11.6-16.6L38.5,19.5h39.8l74.6,106.7,11.6,16.6,96.9,138.6h-39.8l-79.1-113.1h0Z"})))]);
}

TwitterX.defaultProps = {"version":"1.1","viewBox":"0 0 300 300","height":"18"};

module.exports = TwitterX;

TwitterX.default = TwitterX;
